export default "__VITE_ASSET__11c52e0d__"